import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {List, Record} from 'immutable';
import DashBlacklistActions from 'actions/dashboard/DashBlacklistActions';

@immutableStore
class DashBlacklistStore {
  constructor() {
    this.state = Record({
      userIds: List(),
    })();
    this.bindActions(DashBlacklistActions);
  }

  fetchBlacklistSuccess(userIds) {
    this.setState({userIds: List(userIds)});
  }
}

export default alt.createStore(DashBlacklistStore);
